import React from 'react';
import { Field, Control, Label, Radio } from "rbx";

const RadioButton = (props) => {
  const { name, radios=[], onChange, ...other } = props;

  return (
    <Field>
      <Control>
        {
          radios.map((radio, index) => 
              <Label>
                <Radio 
                  key={index}
                  name={name} 
                  value={radio.value}
                  onChange={onChange}
                  {...other}
                /> {radio.label}
              </Label>
          )
        }
      </Control>
    </Field>
  )

}

export default RadioButton;
